<template>
  <section id="search-results" class="card has-background-dark has-text-light" :style="visible ? 'display: block' : 'display: none'">
    <div class="card-content">
      <div class="content list is-hoverable has-background-dark">
        <div class="card-buttons">
          <div>
            <b-button @click="openChartModal" icon-left="chart-areaspline" class="is-dark has-background-black-bis">{{ $t('view.chart') }}</b-button>
          </div>
          <div>
            <b-button @click="clear" icon-left="chart-areaspline" class="is-dark has-background-black-bis">{{ $t('view.chart.clear') }}</b-button>
          </div>
        </div>
        <div class="search-entry" v-for="(row) of results" :key="row.parcel_foreign_id">
          <div>
            <div v-for="(option) of columns" :key="option" v-if="row[option]">
              <label >{{ $t('search.result.columns.' + option)}}:</label> 
              <span v-if="option === 'area'">{{formatArea(row[option])}}</span>
              <span v-if="option !== 'area'">{{row[option]}}</span>
            </div>
          </div>
          <div>
            <a class="list-item has-text-white has-background-dark" @click="close(row)">
              <b-icon icon="close" type="is-white"></b-icon>
            </a>
            <a class="list-item has-text-white has-background-dark" @click="open(row)">
              <b-icon icon="arrow-right" type="is-white"></b-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import ChartModalComponent from 'comp/chart/ChartModal'

export default {
  name: 'SearchResultsComponent',
  props: {
    visible: Boolean
  },
  data () {
    return {
      isOpen: false,
      columns: this.$conf.search[this.$store.getters['searchIndex']].properties || [],
      actionQueue: []
    }
  },
  computed: {
    results () {
      return this.$store.getters['searchResults']
    }
  },
  mounted () {

  },
  methods: {
    open (row) {
      this.$map.fitTo({
        bbox: this.$map.bbox(row.geometry),
        srid: this.$conf.api.srid || 'EPSG:4326'
      })
    },
    close (row) {
      var removedSearchResults = this.results.filter(r => r.parcel_foreign_id !== row.parcel_foreign_id)
      this.$store.commit('search_success', removedSearchResults)
    },
    clear () {
      this.$store.commit('search_success', [])
    },
    formatArea (area) {
      return `${(Math.round(area * 100) / 100)} ha`
    },
    openChartModal (e) {
      e && e.preventDefault()
      if (this.results.length !== 0) {
        this.$buefy.modal.open({
          parent: this,
          width: 1440, //Additionaly @media query is set directly in ChartModal.vue, since there is some sort of a bug
          component: ChartModalComponent,
          hasModalCard: true,
          canCancel: ['escape', 'outside'],
          props: {
            parcels: this.results
          }
        })
      }
    },
  }
}

</script>

<style lang="stylus" scoped>
#search-results
  margin: 0px 6px 26px 6px
  border-bottom: 0
  .card-content
    padding: 0
    .list
      box-shadow: none
      a.list-item
        border-radius: 0
        padding-left: 0
        padding-right: 0
        &:last-child
          border-bottom: 0
        .icon
          float: right
    >div
      >button
        margin-bottom: 0.5rem;

.search-entry
  border: 1px solid #dbdbdb;
  margin-bottom: 0.5rem;
  padding: 0.25rem 0.5rem;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  >div:nth-of-type(2)
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  label
    font-weight: bold;

.card-buttons
  display: flex;
  flex-direction: row;
  margin-bottom: 0.25rem;
  >div
    width: 50%
    >button
      width: 100%
  >div:nth-of-type(1)
    padding-right: 0.25rem;

</style>
